<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space clickabe-row" @click="msgAlerta=null">{{ msgAlerta }}</div>


    <div v-show="!modoEdicao">
        <div class="form-edit-page row-space">
            <div v-if="estabelecimentoView">
                <div class="row row-space">
                    <div class="form-item-char10">
                        <label class="label-caption">SIM Nro</label>
                        <div class="field-label field-label-end" >{{ estabelecimentoView.nrosim }}</div>
                    </div>

                    <div class="form-item">
                        <label class="label-caption">Nome</label>
                        <div class="field-label">{{ estabelecimentoView.nmestabelecimento }}</div>
                    </div>

                    <div class="form-item-char20">
                        <label class="label-caption">CPF/CNPJ</label>
                        <div class="field-label field-label-center">{{ estabelecimentoView.cpfcnpj }}</div>
                    </div>

                    <div class="form-item-char50">
                        <label class="label-caption">Atividade</label>
                        <div class="field-label">{{ estabelecimentoView.nmatividade }}</div>
                    </div>
                </div>
            </div>

            <div class="row row-start">
                <div class="form-item-char30">
                    <label class="label-caption" for="edCpf">CPF do Administrador:</label>
                    <input type="text" class="input-center" v-model="edCpf" id="edCpf" v-cpf  maxlength="14"/>
                </div>
                <button type="button" class="btn-small" @click="novoCadastro">Incluir</button>
                <button type="button" class="btn-small" @click="closeForm">Voltar</button>
            </div>
        </div>


        <div v-if="lsDados.length>0" class="table-wrapper"><table>
            <thead><tr>
                <th>Usuário</th>
                <th>Nome</th>
                <th>Celular</th>
                <th>CPF</th>
                <th>Situação</th>
                <th></th>
            </tr></thead>
            
            <tbody><tr v-for="(obj, index) in lsDados" :key="obj.id" @click="editarCadastro(obj)" 
                :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}">
                    <td class="col-width-char10 right">{{ obj.cdusuario }}</td>
                    <td>{{ obj.nmusuario }}</td>
                    <td  class="col-width-fone">{{ obj.celular }}</td>
                    <td  class="col-width-char20 center">{{ obj.cpf }}</td>
                    <td  class="col-width-char10 center">{{ obj.xativo }}</td>
                    <td class="col-width-char05"><div class="row-left">
                        <button class="btn-icon btn-icon--unlink" @click.stop="abrirModal(obj)"></button>
                    </div></td>
            </tr></tbody>
        </table></div>


        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>


    <ConfirmModal ref="confirmModal" />


    <div v-if="modoEdicao">
        <UsuarioEditPage
            :idEdicao="idEdicao"
            :idEstabelecimento="idEstabelecimento"
            :cpf="edCpf"
            :perfilEstabelecimento=true
            @close="modoEdicao = false"
            @save="lerDados" />
    </div>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import UsuarioEditPage from '../formularios/UsuarioEditPage.vue';

const emit = defineEmits(['close']);
const props = defineProps({estabelecimentoView: {type: Object, default: null}});

const confirmModal = ref(null);
const edCpf = ref(null);
const msgAlerta = ref(null);
const nmPesquisa = ref(null);
const idEdicao = ref(0);
const idEstabelecimento = ref(0);
const isLoading = ref(false);
const lsDados = ref([]);
const modoEdicao = ref(false);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);


async function abrirModal(obj) {
    const confirmado = await confirmModal.value.show({
        message: 'Confirma quebra de vínculo do usuário com o estabelecimento?',
        confirmText: 'Sim',
        cancelText: 'Não'
    })

    if (confirmado) {
        await desvincularAdmin(obj);
    }
}

function closeForm() {emit('close');}


async function desvincularAdmin(obj){
    try{
        isLoading.value=true;
        const response = await Api.genericPost('/cad/exec_requisicao', {
            nmrequisicao: 'usuarios_est_excluir',
            id: obj.id,
            idestabelecimento: props.estabelecimentoView.id,
            idlogin: globalStore.idlogin});
        if (response.bolok === 1){
            await lerDados();
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error){msgAlerta.value= error;
    } finally {isLoading.value = false;}
}


function editarCadastro(obj) {
    idEdicao.value = obj.id;
    modoEdicao.value = true;
}


async function lerDados() {
    try{
        idEstabelecimento.value = props.estabelecimentoView ? props.estabelecimentoView.id : 0;
        msgAlerta.value = null;
        isLoading.value = true;
        const req = await Api.genericPost('/listas/usuarios', {
            idep: globalStore.idep, 
            idestabelecimento: idEstabelecimento.value,
            idsim: globalStore.idsim,
            tipo: 2, 
            nmpesquisar: nmPesquisa.value});
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value= error;
    } finally {isLoading.value = false;}
}


async function novoCadastro() {
    msgAlerta.value=null;
    const v = Validar.cPF(edCpf.value);
    if (!v.ok){msgAlerta.value = v.msg; return;}

    // CONSULTAR VIA API SE CPF EXISTE NO CADASTRO DE USUÁRIOS E ENTÃO APENAS VINCULAR
    try{
        const req = await Api.genericPost('/listas/usuarios', {
            idep: globalStore.idep, 
            tipo: 2, 
            strparam1: edCpf.value});
        if (req.length>0){
            const response = await Api.genericPost('/cad/exec_requisicao', {
                nmrequisicao: 'usuarios_est',
                id: req[0].id,
                idestabelecimento: props.estabelecimentoView.id,
                idlogin: globalStore.idlogin});
            if (response.bolok === 1){
                await lerDados();
            }else{
                msgAlerta.value = response.erro;
            }

        }else{
            console.log('nenhum');
            idEdicao.value = 0;
            modoEdicao.value = true;
        }

    } catch (error){msgAlerta.value= error;
    } finally {isLoading.value = false;}
}


const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}


onMounted(lerDados)
</script>